// @flow
import RolesTable from './RolesTable';

export default RolesTable;
